import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  margin: auto;
  width: max-content;
  grid-template-columns: 1fr;
  grid-template-rows: 3fr;
`;

export default Container;
